import { render, staticRenderFns } from "./Book1.vue?vue&type=template&id=ead2a0fc&scoped=true"
import script from "./Book1.vue?vue&type=script&lang=js"
export * from "./Book1.vue?vue&type=script&lang=js"
import style0 from "./Book1.vue?vue&type=style&index=0&id=ead2a0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead2a0fc",
  null
  
)

export default component.exports